/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_HighInputs */

const cs_enum_high = /** @type {(inputs: Enum_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vysoká`)
};

const en_enum_high = /** @type {(inputs: Enum_HighInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High`)
};

/**
* | output |
* | --- |
* | "High" |
*
* @param {Enum_HighInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_high = /** @type {((inputs?: Enum_HighInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_HighInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_high(inputs)
	return cs_enum_high(inputs)
});